import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatterFileType } from '@models/matter';
import { SelectSnapshot, ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Select } from '@ngxs/store';
import { AuthState } from '@state/auth';
import { AuthUser } from '@state/auth/auth.models';
import { BusinessState } from '@state/business';
import {
	FileUpload,
	FileUploadState,
} from '@state/file-upload/fileUpload.state';
import { Observable } from 'rxjs';
import { ICON } from '@core/util/icon';
import { BaseCreateMatterModel } from 'src/app/shared/services/matter/matter.service';
import { NavigationService } from 'src/app/shared/services/nav/nav.service';
import { TestHooks } from './modal.hooks';

@Component({
	selector: 'app-create-matter-modal',
	templateUrl: './modal.component.html',
	styleUrls: ['./modal.component.scss'],
	standalone: false,
})
export class CreateMatterModalComponent implements OnInit {
	testHooks = TestHooks;
	public matterId: string;
	public currentStep = 0;
	public ICON = ICON;
	public fileType: MatterFileType;
	public matterTypes = MatterFileType;
	public paymentRequired = false;
	public title = 'Create a New Matter';

	@SelectSnapshot(AuthState.getLoggedInUser) loggedInUser: AuthUser;
	@Select(FileUploadState.getFileStatus) fileStatusFilter$: Observable<
		(filter: string) => FileUpload
	>;

	@ViewSelectSnapshot(BusinessState.getCanOpenNewFiles)
	canOpenNewFiles: boolean;

	constructor(
		public dialogRef: MatDialogRef<CreateMatterModalComponent>,
		// rome-ignore lint/suspicious/noExplicitAny: <explanation>
		@Inject(MAT_DIALOG_DATA) public data: unknown,
		private navService: NavigationService,
	) {}

	ngOnInit(): void {
		this.dialogRef.addPanelClass('no-padding');
		this.dialogRef.addPanelClass(
			this.canOpenNewFiles ? 'create-matter-modal' : 'payment-required-modal',
		);
		this.paymentRequired = !this.canOpenNewFiles;
	}

	close(): void {
		this.dialogRef.close();
	}

	goToFileUpload(): void {
		this.currentStep = 2;
		this.dialogRef.disableClose = true;
	}

	createFile = (): void => {
		this.currentStep = 1;
	};

	onCreateFile([matterId]: [string, BaseCreateMatterModel]): void {
		this.matterId = matterId;
		this.currentStep = 2;
		if (this.fileType === MatterFileType.REFINANCE) {
			this.navService.goToMatter(matterId);
			this.dialogRef.close();

			return;
		}

		this.goToFileUpload();
	}

	goToIntake = (): void => {
		this.navService.goToCreateMatter(this.matterId);
		this.dialogRef.close();
	};

	goBack = () => {
		this.currentStep--;
	};

	handleUpload(): void {
		this.goToIntake();
	}

	setFileType(fileType: MatterFileType): void {
		this.fileType = fileType;
		if (this.canOpenNewFiles) {
			this.currentStep = 1;
		} else {
			this.dialogRef.removePanelClass('create-matter-modal');
			this.dialogRef.addPanelClass('payment-required-modal');
			this.paymentRequired = true;
		}
	}

	public resetModal(): void {
		this.dialogRef.removePanelClass('payment-required-modal');
		this.dialogRef.addPanelClass('create-matter-modal');
		this.paymentRequired = false;
		this.currentStep = 0;
	}
}
